import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import mPaper from '@material-ui/core/Paper';
import 'boxicons/css/boxicons.min.css';

export const Paper = styled(mPaper)`
  display: flex;
  flex-direction: column;
  padding: 40px;
  width: 650px;
`;

export const Container = styled.div<{ headerHeight: string }>`
  padding-top: 50px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Title = styled(Typography)`
  font-size: 32px !important;
  font-weight: bold !important;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const Icon = styled.i`
  color: #777;
`;

export const FieldContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  div {
    width: 100%;

    input {
      padding-right: 30px;
    }

    .MuiInputBase-inputMultiline {
      padding-right: 30px;
    }
  }

  i {
    position: absolute;
    cursor: pointer;
    right: 0;
    bottom: 5px;
    font-size: 20px;
    transition: opacity 0.3s;

    &:hover {
      opacity: 0.7;
    }
  }
`;
